import React from 'react'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import {
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    MenuItem,
    Checkbox,
    ListItemText,
    InputLabel,
    Select,
    Chip,
    Button,
    OutlinedInput,
    FormGroup
} from '@material-ui/core'
import {
    renderTextField,
    renderRadioGroup,
    renderDatePicker,
    renderSelect
} from './RenderComponent'
import {
    // JOB_CATEGORY,
    CURRENCY_TYPE
} from '../../utils/CommonConstant'
import MomentUtils from '@date-io/moment'
import {
    MuiPickersUtilsProvider
} from 'material-ui-pickers'
import YomaEditor from '../../components/YomaEditor'
import {
    positionInformationValidation
} from '../form/Validation'
import  '../../assets/css/datePicker.css'
// import { CATEGORY_LIST } from '../../actions/ActionType';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
};

function checkContract(contract) {

    if(contract === undefined) {
        return false
    } else if(contract === 'full') {
        return false
    }else {
        return true
    }
}


function PositionInformationForm ({ ...props }){

    const { 
            classes, 
            chooseCategory, 
            deleteCatetory, 
            categories,
            category_list,
            onChangeJobDescription,
            onChangeJobRequirment, 
            entities,
            pristine,
            submitting,
            requiredCategory,
            requireJobDescription,
            requireJobRequirment,
            contract,
            handleSubmit
        } = props

    return (
        
        <form className={classes.form}>
            <GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="position_title"
                        label="Position Title"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <FormControl  variant="outlined" fullWidth className={classes.select}>

                        <InputLabel htmlFor="select-multiple-job-category">
                            Job Category
                        </InputLabel>
                        <Select
                            fullWidth
                            multiline
                            onChange={(event) => chooseCategory(event.target.value)}
                            input={<OutlinedInput id="select-multiple-job-category" labelWidth={100}/>}
                            MenuProps={MenuProps}
                            value=""
                        >
                            {

                                Object.keys(category_list).map((category, key) => (
                                        <MenuItem key={key} value={category}>

                                            <Checkbox checked={categories.indexOf(category) > -1 } />
                                            
                                             <ListItemText primary={category}/>

                                         </MenuItem>
                                ))
                               
                            }
                        </Select>
                    </FormControl>
                </GridItem>
                {
                    requiredCategory && (
                        <span style={{ color: "red" }}>Choose job category.</span>
                    )
                }

                {
                    categories.length > 0 && (
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.select}>
                                <div className={classes.chips}>
                                    {
                                        
                                            categories.map ((value, key) => (
                                                <Chip 
                                                    key={key} 
                                                    label={value} 
                                                    variant="outlined" 
                                                    color="secondary"
                                                    onDelete={deleteCatetory(value)}

                                                />
                                            ))
                                                                    
                                    }
                                </div>
                            </FormControl>
                        </GridItem>
                    )

                }
                
                <GridItem xs={12} sm={12} md={12}>
                    <FormControl style={{marginTop: "15px"}}>

                        <FormLabel >
                            Designation
                        </FormLabel>

                        <FormGroup>
                            <Field 
                                name="designation"
                                component={renderRadioGroup}
                                >

                                    <FormControlLabel
                                        label="Executive"
                                        value="executive"
                                        control = {
                                            <Radio  color="secondary"/>
                                        }
                                    />

                                    <FormControlLabel
                                        label="Manager"
                                        value="manager"
                                        control = {
                                            <Radio  color="secondary"/>
                                        }
                                    />

                                    <FormControlLabel
                                        label="Staff"
                                        value="staff"
                                        control = {
                                            <Radio  color="secondary"/>
                                        }
                                    />

                            </Field>

                        </FormGroup>

                    </FormControl>
 
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <FormControl style={{marginTop: "15px"}}>

                        <FormLabel >
                            Is confidential?
                        </FormLabel>

                        <FormGroup>
                            <Field 
                                name="confidential"
                                component={renderRadioGroup}
                                >

                                    <FormControlLabel
                                        label="Yes"
                                        value="1"
                                        control = {
                                            <Radio  color="secondary"/>
                                        }
                                    />

                                    <FormControlLabel
                                        label="No"
                                        value="0"
                                        control = {
                                            <Radio  color="secondary"/>
                                        }
                                    />

                            </Field>

                        </FormGroup>

                    </FormControl>
 
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>

                    <FormControl style={{marginTop: "15px"}}>

                        <FormLabel >
                            Job Type
                        </FormLabel>

                        <Field 
                            name="contract"
                            component={renderRadioGroup}
                        >

                            <FormControlLabel
                                label="Full Time"
                                value="full"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                            <FormControlLabel
                                label="Part Time"
                                value="part"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                            <FormControlLabel
                                label="Fixed Term"
                                value="fixed"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                        </Field>

                    </FormControl>

                </GridItem>
                {
                    checkContract(contract) && (
                    <GridItem xs={12} sm={12} md={12}>
                        <div>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <Field
                                            name="start_date"
                                            label="Start Date"
                                            placeholder="If Fixed Term, specify period"
                                            component={renderDatePicker}
                                            className="date-picker"
                                        />
                                    </MuiPickersUtilsProvider>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <Field
                                            name="end_date"
                                            label="End Date"
                                            placeholder="If Fixed Term, specify period"
                                            component={renderDatePicker}
                                            className="date-picker"
                                        />
                                    </MuiPickersUtilsProvider>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </GridItem>
                    )
                }

                <GridItem xs={12} sm={12} md={5}>
                    <Field
                        style={classes.input}
                        name="min_salary"
                        component={renderTextField}
                        type="number"
                        label="From (Gross Salary)"
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                    <Field
                        style={classes.input}
                        name="max_salary"
                        component={renderTextField}
                        type="number"
                        label="To (Gross Salary)"
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                    <Field
                        style={classes.input}
                        name="currency_type"
                        component={renderSelect}
                        label="Currency"
                        label_width={75}
                    >
                        {
                            CURRENCY_TYPE.map(( currency, key) => 
                                <MenuItem key={key} value={currency}>
                                    <ListItemText primary={currency}/>
                                </MenuItem>
                            )
                        }
                    
                    </Field>
                </GridItem>

                
                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="entity"
                        component={renderSelect}
                        label="Entity"
                        label_width={50}
                    >
                        <MenuItem value="Select Entity" />
                        {
                            Object.keys(entities).map((entity, key) => 
                                <MenuItem value={entity} key={key}>
                                    {entity}
                                </MenuItem>
                            )
                        }
                       
                    </Field>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="department"
                        component={renderTextField}
                        label="Department"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="department_head_email"
                        component={renderTextField}
                        label="Department Head Email"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="hiring_manager_email"
                        component={renderTextField}
                        label="Hiring Manager Email"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="location"
                        component={renderTextField}
                        label="Location of the Position"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <YomaEditor 
                        placeholder="Job Description" 
                        onChange={onChangeJobDescription} 
                    />
                    {
                        requireJobDescription && (
                            <span style={{ color: "red" }}>Required job description.</span>
                        )
                    }
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <YomaEditor 
                        placeholder="Job Requirement" 
                        onChange={onChangeJobRequirment} 
                    />
                    {
                        requireJobRequirment && (
                            <span style={{ color: "red" }}>Required job requirments.</span>
                        )
                    }
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                      <div className="Button-Holder">
                        <Button
                          className={classes.prev_button}
                          variant="contained"
                          disabled={true}
                          >
                          Previous
                        </Button>
                      </div>
                      
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div className="Button-Holder">
                      <Button
                        className={classes.button}
                        disabled={pristine || submitting}
                        // type="submit"
                        // onClick={() => next()}
                        onClick={handleSubmit}
                        variant="contained"
                        color ="secondary"
                        >
                            Next
                        </Button>
                    </div>
                </GridItem>

            </GridContainer>

    </form> 
    )
} 

PositionInformationForm.propTypes = {
    classes: PropTypes.object.isRequired
}

export default reduxForm({
    form: "PositionInformation",
    validate: positionInformationValidation,
    destroyOnUnmount: false,        
    forceUnregisterOnUnmount: true,
    enableReinitialize: false,
    // initialValues:{
    //     contract: "unselected"
    // }
})(withStyles(requisitionFormStyle) (PositionInformationForm))






















